const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  itemView ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/purchase/item-view', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
